/** Zoo Taxi UI strings for additional country markets. */

export const IT = {
  lang: 'it',
  title: 'Zoo Taxi',
  loading: 'Caricamento…',
  navTrack: 'Traccia spedizione',
  navCalc: 'Calcola percorso',
  navPay: 'Prenota trasporto',
  navCta: 'Paga ora',
  heroKicker: 'Trasporto animali in Italia',
  heroTitle: 'Il tuo animale — in sicurezza da porta a porta',
  heroSub:
    'Trasporto professionale per cani, gatti e altri animali domestici. Percorso, prezzo e tracking — tutto online.',
  trackTitle: 'Tracking online',
  trackHint: 'Inserisci il codice di tracking per vedere percorso e dettagli dell\'animale.',
  trackPlaceholder: 'Codice tracking, es. 9V82JDBN',
  trackBtn: 'Trova animale',
  trackNotFound: 'Spedizione non trovata.',
  trackError: 'Errore durante la ricerca.',
  calcTitle: 'Calcola percorso e prezzo',
  fromLabel: 'Da (mittente)',
  toLabel: 'A (destinatario)',
  streetPh: 'Via',
  cityPh: 'Città',
  weightLabel: 'Peso (kg)',
  calcBtn: 'Calcola percorso',
  calcBusy: 'Calcolo in corso…',
  calcDone: 'Percorso calcolato.',
  kmRoute: 'km di percorso',
  driveTime: 'Tempo di viaggio',
  liveCalc: 'Calcolo in tempo reale',
  baseFee: 'Tariffa base',
  distanceLine: (km) => `Percorso (${km} km × tariffa)`,
  weightOver: 'Peso oltre 5 kg',
  largeSize: 'Taglia grande',
  calcHint: 'Calcola il percorso per vedere il prezzo.',
  priceTotal: 'Prezzo Zoo Taxi',
  payTitle: 'Prenotazione e pagamento',
  customer: 'Cliente',
  route: 'Percorso',
  amount: 'Importo',
  footerTag: 'Trasporto sicuro per i tuoi animali in tutta Italia',
  footerCopy: 'Con cura per i tuoi compagni a quattro zampe.',
  modalBadge: 'In attesa di spedizione',
  modalTitle: 'Ordine ricevuto!',
  modalHint:
    'Conserva il codice di tracking — potrai seguire l\'animale con percorso e foto in tempo reale.',
  copyCode: 'Copia codice',
  copied: 'Copiato!',
  pet: 'Animale',
  trackDetails: 'Dettagli spedizione',
  tracking: 'Tracking',
  from: 'Da',
  to: 'A',
  distTime: 'Percorso / tempo',
  price: 'Prezzo',
  done: 'Fatto',
  close: 'Chiudi',
  fromExample: 'Via del Corso 12, Roma',
  toExample: 'Via Montenapoleone 8, Milano',
  tabSend: 'Invia',
  tabReceive: 'Ricevi',
  sendTitle: 'Richiedi trasporto',
  sendHint: 'Poche informazioni — ti rispondiamo con un preventivo.',
  sendFrom: 'Luogo di ritiro',
  sendTo: 'Destinazione',
  sendPet: 'Animale (nome / specie)',
  sendSubmit: 'Invia richiesta',
  sendDoneTitle: 'Richiesta ricevuta',
  sendDoneText: 'Grazie! Verifichiamo il percorso e ti contattiamo a breve via e-mail.',
  trackModalHead: 'Vista animale e dettagli spedizione',
  trackPaidBadge: '✓ Pagato (addebito SEPA)',
  statusPaidHandover: '✓ Pagato — in attesa della consegna dell\'animale',
  statusInTransit: '🚗 In viaggio — a metà percorso',
  stepAccepted: 'Accettato',
  stepTransit: 'In viaggio',
  stepDelivered: 'Consegnato',
  distance: 'Distanza',
  plannedTime: 'Tempo di viaggio previsto',
  firstName: 'Nome',
  lastName: 'Cognome',
  addressLabel: 'Indirizzo',
  payNow: 'Paga ora',
  cancelRefundBtn: 'Annulla ordine e richiedi rimborso',
  refundPageKicker: 'Rimborso',
  refundPageTitle: 'Annulla ordine e richiedi rimborso',
  refundPageHint: 'Controlla i dettagli della spedizione e conferma il rimborso sulla tua carta.',
  refundHeadline: 'Rimborso richiesto',
  refundHint: 'Inserisci la carta su cui effettuare il rimborso.',
  refundFormTitle: 'Carta per il rimborso',
  refundSubmit: 'Rimborsa',
  whyTitle: 'Perché sceglierci?',
  why1Title: 'Con amore e attenzione',
  why1Text:
    'Siamo pazienti e delicati con ogni passeggero. Creiamo un ambiente tranquillo perché il tuo animale si senta a suo agio.',
  why2Title: 'Sicurezza totale',
  why2Text:
    'Trasportini speciali, cinture e aree protette nei nostri veicoli — per un viaggio sicuro da porta a porta.',
  why3Title: 'Pulizia e igiene',
  why3Text:
    'I nostri veicoli vengono disinfettati dopo ogni corsa. Acqua fresca e kit di cura sempre a bordo.',
  servicesTitle: 'I nostri servizi',
  svc1Title: 'Trasporto animali',
  svc1Text:
    'Trasporto sicuro di cani, gatti e altri animali in città e regione — in condizioni confortevoli.',
  svc2Title: 'Visita dal veterinario',
  svc2Text: 'Trasferimenti urgenti o programmati in clinica veterinaria. Aiuto nel trasporto e nell\'accompagnamento.',
  svc3Title: 'Ritiro dall\'allevatore',
  svc3Text:
    'Ritiriamo il tuo nuovo amico dall\'allevatore o dal rifugio e lo portiamo con cura a casa tua.',
  faqTitle: 'Domande frequenti sul trasporto animali',
  faq1Q: 'Come vengono trasportati i cani?',
  faq1A:
    'Garantiamo un trasporto sicuro con cinture e trasportini dedicati. Ogni viaggio è seguito con cura e attenzione al tuo animale.',
  faq2Q: 'Trasportate anche i gatti?',
  faq2A:
    'Sì, siamo specializzati nel trasporto dei gatti. Usiamo trasportini anti-stress e manteniamo una temperatura confortevole in auto.',
  faq3Q: 'Offrite servizi d\'emergenza?',
  faq3A:
    'Sì, effettuiamo anche trasferimenti urgenti dal veterinario o in altre situazioni critiche. Chiamaci — cerchiamo di aiutarti in ogni caso!',
  aboutTitle: 'Il nostro servizio',
  about1:
    'Zoo Taxi è un servizio professionale di trasporto per cani, gatti e altri animali domestici. Portiamo i tuoi amici in sicurezza a casa, dal veterinario o dall\'allevatore — sempre con delicatezza e senza stress.',
  about2:
    'I nostri autisti hanno esperienza con gli animali e garantiscono un viaggio tranquillo e confortevole. Trasportini, cinture e climatizzazione sono standard.',
  about3:
    'Che si tratti di un appuntamento programmato o di un trasferimento urgente — trattiamo ogni animale come fosse nostro.',
  aboutQuote:
    '«Trattiamo ogni cane, gatto o altro animale come tratteremmo il nostro.»',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Trasporto sicuro e confortevole per i tuoi animali',
  mapRouteTitle: 'Percorso di trasporto',
  mapLoading: 'Caricamento mappa…',
  trackDetailsBtn: 'Mostra tutti i dettagli',
  sendAddressError: 'Indica città di ritiro e di destinazione.',
  checkoutPaidTitle: 'Pagamento riuscito',
  checkoutAmountLabel: 'Importo:',
  checkoutSecureMessage: 'Il pagamento è stato elaborato in sicurezza. La spedizione è in preparazione.',
  checkoutContinueBtn: 'Continua',
  checkoutCardFormTitle: 'Carta per il pagamento',
  refundSuccessTitle: 'Rimborso avviato',
  refundSuccessMessage: 'Il rimborso verrà accreditato sulla carta indicata.',
  refundSuccessBtn: 'Torna alla spedizione',
};

export const FR = {
  lang: 'fr',
  title: 'Zoo Taxi',
  loading: 'Chargement…',
  navTrack: 'Suivre l\'envoi',
  navCalc: 'Calculer l\'itinéraire',
  navPay: 'Réserver un transport',
  navCta: 'Payer maintenant',
  heroKicker: 'Transport d\'animaux en France',
  heroTitle: 'Votre animal — en toute sécurité de porte à porte',
  heroSub:
    'Transport professionnel pour chiens, chats et autres animaux de compagnie. Itinéraire, prix et suivi — tout en ligne.',
  trackTitle: 'Suivi en ligne',
  trackHint: 'Saisissez votre numéro de suivi pour voir l\'itinéraire et les détails de l\'animal.',
  trackPlaceholder: 'Code de suivi, ex. 9V82JDBN',
  trackBtn: 'Trouver l\'animal',
  trackNotFound: 'Envoi introuvable.',
  trackError: 'Erreur lors de la recherche.',
  calcTitle: 'Calculer l\'itinéraire et le prix',
  fromLabel: 'De (expéditeur)',
  toLabel: 'À (destinataire)',
  streetPh: 'Rue',
  cityPh: 'Ville',
  weightLabel: 'Poids (kg)',
  calcBtn: 'Calculer l\'itinéraire',
  calcBusy: 'Calcul en cours…',
  calcDone: 'Itinéraire calculé.',
  kmRoute: 'km de trajet',
  driveTime: 'Temps de route',
  liveCalc: 'Calcul en direct',
  baseFee: 'Frais de base',
  distanceLine: (km) => `Trajet (${km} km × tarif)`,
  weightOver: 'Poids supérieur à 5 kg',
  largeSize: 'Grande taille',
  calcHint: 'Calculez l\'itinéraire pour voir le prix.',
  priceTotal: 'Prix Zoo Taxi',
  payTitle: 'Réservation et paiement',
  customer: 'Client',
  route: 'Itinéraire',
  amount: 'Montant',
  footerTag: 'Transport sécurisé pour vos animaux dans toute la France',
  footerCopy: 'Avec soin pour vos compagnons.',
  modalBadge: 'En attente d\'expédition',
  modalTitle: 'Commande reçue !',
  modalHint:
    'Conservez votre numéro de suivi — il vous permet de suivre l\'animal avec l\'itinéraire et une photo.',
  copyCode: 'Copier le code',
  copied: 'Copié !',
  pet: 'Animal',
  trackDetails: 'Détails de l\'envoi',
  tracking: 'Suivi',
  from: 'De',
  to: 'À',
  distTime: 'Trajet / durée',
  price: 'Prix',
  done: 'Terminé',
  close: 'Fermer',
  fromExample: '12 rue de Rivoli, Paris',
  toExample: '8 place Bellecour, Lyon',
  tabSend: 'Envoyer',
  tabReceive: 'Recevoir',
  sendTitle: 'Demander un transport',
  sendHint: 'Quelques informations — nous vous répondons avec un devis.',
  sendFrom: 'Lieu de prise en charge',
  sendTo: 'Destination',
  sendPet: 'Animal (nom / espèce)',
  sendSubmit: 'Envoyer la demande',
  sendDoneTitle: 'Demande reçue',
  sendDoneText: 'Merci ! Nous vérifions l\'itinéraire et vous contactons sous peu par e-mail.',
  trackModalHead: 'Vue animal et détails de l\'envoi',
  trackPaidBadge: '✓ Payé (prélèvement SEPA)',
  statusPaidHandover: '✓ Payé — en attente de remise de l\'animal',
  statusInTransit: '🚗 En route — à mi-parcours',
  stepAccepted: 'Accepté',
  stepTransit: 'En route',
  stepDelivered: 'Livré',
  distance: 'Distance',
  plannedTime: 'Durée prévue',
  firstName: 'Prénom',
  lastName: 'Nom',
  addressLabel: 'Adresse',
  payNow: 'Payer maintenant',
  cancelRefundBtn: 'Annuler la commande et demander un remboursement',
  refundPageKicker: 'Remboursement',
  refundPageTitle: 'Annuler la commande et demander un remboursement',
  refundPageHint: 'Vérifiez les détails de l\'envoi et confirmez le remboursement sur votre carte.',
  refundHeadline: 'Remboursement requis',
  refundHint: 'Indiquez la carte sur laquelle effectuer le remboursement.',
  refundFormTitle: 'Carte pour le remboursement',
  refundSubmit: 'Rembourser',
  whyTitle: 'Pourquoi nous choisir ?',
  why1Title: 'Avec amour et attention',
  why1Text:
    'Nous sommes patients et bienveillants avec chaque passager. Nous créons une atmosphère calme pour que votre animal se sente à l\'aise.',
  why2Title: 'Sécurité maximale',
  why2Text:
    'Caisses de transport spéciales, harnais et zones sécurisées dans nos véhicules — pour un trajet sûr de porte à porte.',
  why3Title: 'Propreté et hygiène',
  why3Text:
    'Nos véhicules sont désinfectés après chaque course. Eau fraîche et kit de soins toujours à bord.',
  servicesTitle: 'Nos services',
  svc1Title: 'Transport d\'animaux',
  svc1Text:
    'Transport sécurisé de chiens, chats et autres animaux en ville et en région — dans des conditions confortables.',
  svc2Title: 'Trajet chez le vétérinaire',
  svc2Text: 'Transferts urgents ou planifiés vers une clinique vétérinaire. Aide au portage et à l\'accompagnement.',
  svc3Title: 'Récupération chez l\'éleveur',
  svc3Text:
    'Nous récupérons votre nouveau compagnon chez l\'éleveur ou au refuge et le ramèneons délicatement chez vous.',
  faqTitle: 'Questions fréquentes sur le transport d\'animaux',
  faq1Q: 'Comment les chiens sont-ils transportés ?',
  faq1A:
    'Nous assurons un transport sécurisé avec harnais et caisses dédiées. Chaque trajet est effectué avec soin et attention pour votre animal.',
  faq2Q: 'Transportez-vous aussi les chats ?',
  faq2A:
    'Oui, nous sommes spécialisés dans le transport de chats. Nous utilisons des caisses anti-stress et maintenons une température agréable dans le véhicule.',
  faq3Q: 'Proposez-vous des services d\'urgence ?',
  faq3A:
    'Oui, nous effectuons aussi des transferts urgents chez le vétérinaire ou dans d\'autres situations critiques. Appelez-nous — nous faisons de notre mieux pour vous aider !',
  aboutTitle: 'Notre service',
  about1:
    'Zoo Taxi est un service professionnel de transport pour chiens, chats et autres animaux de compagnie. Nous emmenons vos compagnons en toute sécurité à domicile, chez le vétérinaire ou depuis l\'éleveur — toujours avec douceur et sans stress.',
  about2:
    'Nos chauffeurs sont expérimentés avec les animaux et veillent à ce que chaque trajet soit calme et confortable. Caisses, harnais et climatisation sont standard.',
  about3:
    'Qu\'il s\'agisse d\'un rendez-vous planifié ou d\'un transfert urgent — nous traitons chaque animal comme s\'il était le nôtre.',
  aboutQuote:
    '« Nous traitons chaque chien, chat ou autre animal comme nous traiterions le nôtre. »',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Transport sûr et confortable pour vos animaux',
  mapRouteTitle: 'Itinéraire de transport',
  mapLoading: 'Chargement de la carte…',
  trackDetailsBtn: 'Afficher tous les détails',
  sendAddressError: 'Veuillez indiquer les villes de prise en charge et de destination.',
  checkoutPaidTitle: 'Paiement réussi',
  checkoutAmountLabel: 'Montant :',
  checkoutSecureMessage: 'Votre paiement a été traité en toute sécurité. L\'envoi est en préparation.',
  checkoutContinueBtn: 'Continuer',
  checkoutCardFormTitle: 'Carte pour le paiement',
  refundSuccessTitle: 'Remboursement initié',
  refundSuccessMessage: 'Le remboursement sera versé sur la carte indiquée.',
  refundSuccessBtn: 'Retour à l\'envoi',
};

export const NO = {
  lang: 'no',
  title: 'Zoo Taxi',
  loading: 'Laster…',
  navTrack: 'Spor forsendelse',
  navCalc: 'Beregn rute',
  navPay: 'Bestill transport',
  navCta: 'Betal nå',
  heroKicker: 'Dytransport i Norge',
  heroTitle: 'Ditt kjæledyr — trygt fra dør til dør',
  heroSub:
    'Profesjonell transport for hunder, katter og andre kjæledyr. Rute, pris og sporing — alt på nett.',
  trackTitle: 'Sporing på nett',
  trackHint: 'Skriv inn sporingsnummeret for å se rute og dyredetaljer.',
  trackPlaceholder: 'Sporingskode, f.eks. 9V82JDBN',
  trackBtn: 'Finn dyret',
  trackNotFound: 'Forsendelse ikke funnet.',
  trackError: 'Feil under søk.',
  calcTitle: 'Beregn rute og pris',
  fromLabel: 'Fra (avsender)',
  toLabel: 'Til (mottaker)',
  streetPh: 'Gate',
  cityPh: 'By',
  weightLabel: 'Vekt (kg)',
  calcBtn: 'Beregn rute',
  calcBusy: 'Beregner…',
  calcDone: 'Rute beregnet.',
  kmRoute: 'km rute',
  driveTime: 'Kjøretid',
  liveCalc: 'Live-beregning',
  baseFee: 'Grunngebyr',
  distanceLine: (km) => `Strekning (${km} km × sats)`,
  weightOver: 'Vekt over 5 kg',
  largeSize: 'Stor størrelse',
  calcHint: 'Beregn ruten for å se prisen i NOK.',
  priceTotal: 'Zoo Taxi-pris',
  payTitle: 'Bestilling og betaling',
  customer: 'Kunde',
  route: 'Rute',
  amount: 'Beløp',
  footerTag: 'Trygg transport for kjæledyrene dine i hele Norge',
  footerCopy: 'Med omsorg for dine firbeinte venner.',
  modalBadge: 'Venter på sending',
  modalTitle: 'Bestilling mottatt!',
  modalHint:
    'Ta vare på sporingsnummeret — med det kan du følge dyret med rute og bilde.',
  copyCode: 'Kopier kode',
  copied: 'Kopiert!',
  pet: 'Dyr',
  trackDetails: 'Forsendelsesdetaljer',
  tracking: 'Sporing',
  from: 'Fra',
  to: 'Til',
  distTime: 'Strekning / tid',
  price: 'Pris',
  done: 'Ferdig',
  close: 'Lukk',
  fromExample: 'Karl Johans gate 15, Oslo',
  toExample: 'Bryggen 7, Bergen',
  tabSend: 'Send',
  tabReceive: 'Motta',
  sendTitle: 'Be om transport',
  sendHint: 'Kort info — vi svarer med et tilbud.',
  sendFrom: 'Hentested',
  sendTo: 'Destinasjon',
  sendPet: 'Dyr (navn / art)',
  sendSubmit: 'Send forespørsel',
  sendDoneTitle: 'Forespørsel mottatt',
  sendDoneText: 'Takk! Vi sjekker ruten og kontakter deg snart på e-post.',
  trackModalHead: 'Dyvisning og forsendelsesdetaljer',
  trackPaidBadge: '✓ Betalt (SEPA-belastning)',
  statusPaidHandover: '✓ Betalt — venter på overlevering av dyret',
  statusInTransit: '🚗 Underveis — halvveis på ruten',
  stepAccepted: 'Akseptert',
  stepTransit: 'Underveis',
  stepDelivered: 'Levert',
  distance: 'Avstand',
  plannedTime: 'Planlagt kjøretid',
  firstName: 'Fornavn',
  lastName: 'Etternavn',
  addressLabel: 'Adresse',
  payNow: 'Betal nå',
  cancelRefundBtn: 'Avbestill og få pengene tilbake',
  refundPageKicker: 'Refusjon',
  refundPageTitle: 'Avbestill og få pengene tilbake',
  refundPageHint: 'Kontroller forsendelsesdetaljene og bekreft refusjonen til kortet ditt.',
  refundHeadline: 'Refusjon kreves',
  refundHint: 'Oppgi kortet refusjonen skal gå til.',
  refundFormTitle: 'Kort for refusjon',
  refundSubmit: 'Refunder',
  whyTitle: 'Hvorfor velge oss?',
  why1Title: 'Med omsorg og kjærlighet',
  why1Text:
    'Vi er tålmodige og empatiske med hvert passasjer. Vi skaper en rolig atmosfære slik at kjæledyret ditt føler seg trygt.',
  why2Title: 'Full sikkerhet',
  why2Text:
    'Spesialtransportere, seler og sikre soner i bilene våre — for en trygg tur fra dør til dør.',
  why3Title: 'Renhold og hygiene',
  why3Text:
    'Kjøretøyene våre desinfiseres etter hver tur. Friskt vann og pleieutstyr er alltid med.',
  servicesTitle: 'Våre tjenester',
  svc1Title: 'Dytransport',
  svc1Text:
    'Trygg transport av hunder, katter og andre dyr i by og region — under komfortable forhold.',
  svc2Title: 'Tur til veterinær',
  svc2Text: 'Akutte eller planlagte turer til dyreklinikk. Hjelp med bæring og følge.',
  svc3Title: 'Henting fra oppdretter',
  svc3Text:
    'Vi henter din nye venn fra oppdretter eller dyrehjem og bringer den forsiktig hjem til deg.',
  faqTitle: 'Ofte stilte spørsmål om dytransport',
  faq1Q: 'Hvordan transporteres hunder?',
  faq1A:
    'Vi sørger for trygg transport med spesialseler og bur. Hver tur følges med omsorg og oppmerksomhet for kjæledyret ditt.',
  faq2Q: 'Kan katter transporteres?',
  faq2A:
    'Ja, vi er spesialisert på katte transport. Vi bruker anti-stress-bur og sørger for behagelig temperatur i bilen.',
  faq3Q: 'Tilbyr dere nødtjenester?',
  faq3A:
    'Ja, vi kjører også akutt til veterinær eller i andre nødsituasjoner. Ring oss — vi prøver å hjelpe i enhver situasjon!',
  aboutTitle: 'Om tjenesten vår',
  about1:
    'Zoo Taxi er en profesjonell transporttjeneste for hunder, katter og andre kjæledyr. Vi bringer vennene dine trygt hjem, til veterinær eller fra oppdretter — alltid skånsomt og stressfritt.',
  about2:
    'Sjåførene våre har erfaring med dyr og sørger for at hver tur er rolig og behagelig. Spesialbur, seler og klimaanlegg er standard.',
  about3:
    'Enten det er en planlagt avtale eller en akutt tur — vi behandler hvert dyr som om det var vårt eget.',
  aboutQuote:
    '«Vi behandler hver hund, katt eller annet kjæledyr som vi ville behandlet vårt eget.»',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Trygg og komfortabel transport for kjæledyrene dine',
  mapRouteTitle: 'Transportrute',
  mapLoading: 'Laster kart…',
  trackDetailsBtn: 'Vis alle detaljer',
  sendAddressError: 'Oppgi hente- og destinasjonsby.',
  checkoutPaidTitle: 'Betaling vellykket',
  checkoutAmountLabel: 'Beløp:',
  checkoutSecureMessage: 'Betalingen din ble behandlet trygt. Forsendelsen forberedes.',
  checkoutContinueBtn: 'Fortsett',
  checkoutCardFormTitle: 'Kort for betaling',
  refundSuccessTitle: 'Refusjon igangsatt',
  refundSuccessMessage: 'Refusjonen overføres til det oppgitte kortet.',
  refundSuccessBtn: 'Tilbake til forsendelse',
};

export const SE = {
  lang: 'sv',
  title: 'Zoo Taxi',
  loading: 'Laddar…',
  navTrack: 'Spåra försändelse',
  navCalc: 'Beräkna rutt',
  navPay: 'Boka transport',
  navCta: 'Betala nu',
  heroKicker: 'Djurtransport i Sverige',
  heroTitle: 'Ditt husdjur — tryggt från dörr till dörr',
  heroSub:
    'Professionell transport för hundar, katter och andra husdjur. Rutt, pris och spårning — allt online.',
  trackTitle: 'Spårning online',
  trackHint: 'Ange ditt spårningsnummer för att se rutt och djurdetaljer.',
  trackPlaceholder: 'Spårningskod, t.ex. 9V82JDBN',
  trackBtn: 'Hitta djur',
  trackNotFound: 'Försändelse hittades inte.',
  trackError: 'Fel vid sökning.',
  calcTitle: 'Beräkna rutt och pris',
  fromLabel: 'Från (avsändare)',
  toLabel: 'Till (mottagare)',
  streetPh: 'Gata',
  cityPh: 'Stad',
  weightLabel: 'Vikt (kg)',
  calcBtn: 'Beräkna rutt',
  calcBusy: 'Beräknar…',
  calcDone: 'Rutt beräknad.',
  kmRoute: 'km rutt',
  driveTime: 'Körtid',
  liveCalc: 'Liveberäkning',
  baseFee: 'Grundavgift',
  distanceLine: (km) => `Sträcka (${km} km × taxa)`,
  weightOver: 'Vikt över 5 kg',
  largeSize: 'Stor storlek',
  calcHint: 'Beräkna rutten för att se priset.',
  priceTotal: 'Zoo Taxi-pris',
  payTitle: 'Bokning och betalning',
  customer: 'Kund',
  route: 'Rutt',
  amount: 'Belopp',
  footerTag: 'Trygg transport för dina husdjur i hela Sverige',
  footerCopy: 'Med omsorg om dina fyrbenta vänner.',
  modalBadge: 'Väntar på sändning',
  modalTitle: 'Beställning mottagen!',
  modalHint:
    'Spara spårningsnumret — med det kan du följa djuret med rutt och foto.',
  copyCode: 'Kopiera kod',
  copied: 'Kopierat!',
  pet: 'Djur',
  trackDetails: 'Försändelsedetaljer',
  tracking: 'Spårning',
  from: 'Från',
  to: 'Till',
  distTime: 'Sträcka / tid',
  price: 'Pris',
  done: 'Klar',
  close: 'Stäng',
  fromExample: 'Drottninggatan 18, Stockholm',
  toExample: 'Avenyn 12, Göteborg',
  tabSend: 'Skicka',
  tabReceive: 'Ta emot',
  sendTitle: 'Begär transport',
  sendHint: 'Kort info — vi återkommer med ett erbjudande.',
  sendFrom: 'Upphämtningsplats',
  sendTo: 'Destination',
  sendPet: 'Djur (namn / art)',
  sendSubmit: 'Skicka förfrågan',
  sendDoneTitle: 'Förfrågan mottagen',
  sendDoneText: 'Tack! Vi kontrollerar rutten och hör av oss inom kort via e-post.',
  trackModalHead: 'Djurvy och försändelsedetaljer',
  trackPaidBadge: '✓ Betald (SEPA-dragning)',
  statusPaidHandover: '✓ Betald — väntar på överlämning av djuret',
  statusInTransit: '🚗 På väg — halvvägs på rutten',
  stepAccepted: 'Accepterad',
  stepTransit: 'På väg',
  stepDelivered: 'Levererad',
  distance: 'Avstånd',
  plannedTime: 'Planerad körtid',
  firstName: 'Förnamn',
  lastName: 'Efternamn',
  addressLabel: 'Adress',
  payNow: 'Betala nu',
  cancelRefundBtn: 'Avboka och få pengarna tillbaka',
  refundPageKicker: 'Återbetalning',
  refundPageTitle: 'Avboka och få pengarna tillbaka',
  refundPageHint: 'Kontrollera försändelsedetaljerna och bekräfta återbetalningen till ditt kort.',
  refundHeadline: 'Återbetalning krävs',
  refundHint: 'Ange kortet som återbetalningen ska gå till.',
  refundFormTitle: 'Kort för återbetalning',
  refundSubmit: 'Återbetala',
  whyTitle: 'Varför välja oss?',
  why1Title: 'Med omsorg och kärlek',
  why1Text:
    'Vi är tålmodiga och empatiska med varje passagerare. Vi skapar en lugn atmosfär så att ditt husdjur känner sig tryggt.',
  why2Title: 'Full säkerhet',
  why2Text:
    'Specialburar, selar och säkra zoner i våra fordon — för en trygg resa från dörr till dörr.',
  why3Title: 'Renlighet och hygien',
  why3Text:
    'Våra fordon desinficeras efter varje resa. Friskt vatten och omvårdnadskit finns alltid ombord.',
  servicesTitle: 'Våra tjänster',
  svc1Title: 'Djurtransport',
  svc1Text:
    'Trygg transport av hundar, katter och andra djur i stad och region — under bekväma förhållanden.',
  svc2Title: 'Resa till veterinär',
  svc2Text: 'Akuta eller planerade resor till djurklinik. Hjälp med bärning och följeslag.',
  svc3Title: 'Hämtning från uppfödare',
  svc3Text:
    'Vi hämtar din nya vän från uppfödare eller djurhem och tar försiktigt hem den till dig.',
  faqTitle: 'Vanliga frågor om djurtransport',
  faq1Q: 'Hur transporteras hundar?',
  faq1A:
    'Vi ser till att transporten är säker med specialselar och burar. Varje resa följs med omsorg och uppmärksamhet för ditt husdjur.',
  faq2Q: 'Kan katter transporteras?',
  faq2A:
    'Ja, vi är specialiserade på kattransport. Vi använder anti-stress-burar och ser till att temperaturen i bilen är behaglig.',
  faq3Q: 'Erbjuder ni akuttjänster?',
  faq3A:
    'Ja, vi kör även akut till veterinär eller i andra nödsituationer. Ring oss — vi försöker hjälpa i alla lägen!',
  aboutTitle: 'Om vår tjänst',
  about1:
    'Zoo Taxi är en professionell transporttjänst för hundar, katter och andra husdjur. Vi tar dina vänner säkert hem, till veterinär eller från uppfödare — alltid varsamt och stressfritt.',
  about2:
    'Våra chaufförer har erfarenhet av djur och ser till att varje resa är lugn och bekväm. Specialburar, selar och klimatanläggning är standard.',
  about3:
    'Oavsett om det är ett planerat möte eller en akut resa — vi behandlar varje djur som om det vore vårt eget.',
  aboutQuote:
    '«Vi behandlar varje hund, katt eller annat husdjur som vi skulle behandla vårt eget.»',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Trygg och bekväm transport för dina husdjur',
  mapRouteTitle: 'Transportrutt',
  mapLoading: 'Laddar karta…',
  trackDetailsBtn: 'Visa alla detaljer',
  sendAddressError: 'Ange upphämtnings- och destinationsstad.',
  checkoutPaidTitle: 'Betalning lyckades',
  checkoutAmountLabel: 'Belopp:',
  checkoutSecureMessage: 'Din betalning har behandlats säkert. Försändelsen förbereds.',
  checkoutContinueBtn: 'Fortsätt',
  checkoutCardFormTitle: 'Kort för betalning',
  refundSuccessTitle: 'Återbetalning påbörjad',
  refundSuccessMessage: 'Återbetalningen överförs till angivet kort.',
  refundSuccessBtn: 'Tillbaka till försändelse',
};

export const DK = {
  lang: 'da',
  title: 'Zoo Taxi',
  loading: 'Indlæser…',
  navTrack: 'Spor forsendelse',
  navCalc: 'Beregn rute',
  navPay: 'Bestil transport',
  navCta: 'Betal nu',
  heroKicker: 'Dytransport i Danmark',
  heroTitle: 'Dit kæledyr — sikkert fra dør til dør',
  heroSub:
    'Professionel transport for hunde, katte og andre kæledyr. Rute, pris og sporing — alt online.',
  trackTitle: 'Sporing online',
  trackHint: 'Indtast dit sporingsnummer for at se rute og dyredetaljer.',
  trackPlaceholder: 'Sporingskode, f.eks. 9V82JDBN',
  trackBtn: 'Find dyret',
  trackNotFound: 'Forsendelse ikke fundet.',
  trackError: 'Fejl under søgning.',
  calcTitle: 'Beregn rute og pris',
  fromLabel: 'Fra (afsender)',
  toLabel: 'Til (modtager)',
  streetPh: 'Gade',
  cityPh: 'By',
  weightLabel: 'Vægt (kg)',
  calcBtn: 'Beregn rute',
  calcBusy: 'Beregner…',
  calcDone: 'Rute beregnet.',
  kmRoute: 'km rute',
  driveTime: 'Køretid',
  liveCalc: 'Live-beregning',
  baseFee: 'Grundgebyr',
  distanceLine: (km) => `Strækning (${km} km × sats)`,
  weightOver: 'Vægt over 5 kg',
  largeSize: 'Stor størrelse',
  calcHint: 'Beregn ruten for at se prisen.',
  priceTotal: 'Zoo Taxi-pris',
  payTitle: 'Bestilling og betaling',
  customer: 'Kunde',
  route: 'Rute',
  amount: 'Beløb',
  footerTag: 'Sikker transport for dine kæledyr i hele Danmark',
  footerCopy: 'Med omsorg for dine firbenede venner.',
  modalBadge: 'Venter på afsendelse',
  modalTitle: 'Ordre modtaget!',
  modalHint:
    'Gem sporingsnummeret — med det kan du følge dyret med rute og foto.',
  copyCode: 'Kopier kode',
  copied: 'Kopieret!',
  pet: 'Dyr',
  trackDetails: 'Forsendelsesdetaljer',
  tracking: 'Sporing',
  from: 'Fra',
  to: 'Til',
  distTime: 'Strækning / tid',
  price: 'Pris',
  done: 'Færdig',
  close: 'Luk',
  fromExample: 'Strøget 22, København',
  toExample: 'Store Torv 5, Aarhus',
  tabSend: 'Send',
  tabReceive: 'Modtag',
  sendTitle: 'Anmod om transport',
  sendHint: 'Kort info — vi vender tilbage med et tilbud.',
  sendFrom: 'Afhentningssted',
  sendTo: 'Destination',
  sendPet: 'Dyr (navn / art)',
  sendSubmit: 'Send forespørgsel',
  sendDoneTitle: 'Forespørgsel modtaget',
  sendDoneText: 'Tak! Vi tjekker ruten og kontakter dig snart via e-mail.',
  trackModalHead: 'Dyvisning og forsendelsesdetaljer',
  trackPaidBadge: '✓ Betalt (SEPA-belastning)',
  statusPaidHandover: '✓ Betalt — venter på overdragelse af dyret',
  statusInTransit: '🚗 Undervejs — halvvejs på ruten',
  stepAccepted: 'Accepteret',
  stepTransit: 'Undervejs',
  stepDelivered: 'Leveret',
  distance: 'Afstand',
  plannedTime: 'Planlagt køretid',
  firstName: 'Fornavn',
  lastName: 'Efternavn',
  addressLabel: 'Adresse',
  payNow: 'Betal nu',
  cancelRefundBtn: 'Annuller ordre og få pengene tilbage',
  refundPageKicker: 'Refusion',
  refundPageTitle: 'Annuller ordre og få pengene tilbage',
  refundPageHint: 'Tjek forsendelsesdetaljerne og bekræft refusionen til dit kort.',
  refundHeadline: 'Refusion påkrævet',
  refundHint: 'Angiv kortet, refusionen skal gå til.',
  refundFormTitle: 'Kort til refusion',
  refundSubmit: 'Refunder',
  whyTitle: 'Hvorfor vælge os?',
  why1Title: 'Med omsorg og kærlighed',
  why1Text:
    'Vi er tålmodige og empatiske over for hver passager. Vi skaber en rolig atmosfære, så dit kæledyr føler sig trygt.',
  why2Title: 'Fuld sikkerhed',
  why2Text:
    'Specialtransportkasser, seler og sikre zoner i vores køretøjer — for en sikker tur fra dør til dør.',
  why3Title: 'Renlighed og hygiejne',
  why3Text:
    'Vores køretøjer desinficeres efter hver tur. Frisk vand og plejeudstyr er altid med.',
  servicesTitle: 'Vores tjenester',
  svc1Title: 'Dytransport',
  svc1Text:
    'Sikker transport af hunde, katte og andre dyr i by og region — under komfortable forhold.',
  svc2Title: 'Tur til dyrlæge',
  svc2Text: 'Akutte eller planlagte ture til dyreklinik. Hjælp med bæring og ledsagelse.',
  svc3Title: 'Afhentning fra opdrætter',
  svc3Text:
    'Vi henter din nye ven fra opdrætter eller internat og bringer den forsigtigt hjem til dig.',
  faqTitle: 'Ofte stillede spørgsmål om dytransport',
  faq1Q: 'Hvordan transporteres hunde?',
  faq1A:
    'Vi sørger for sikker transport med specialseler og bure. Hver tur følges med omsorg og opmærksomhed for dit kæledyr.',
  faq2Q: 'Kan katte transporteres?',
  faq2A:
    'Ja, vi er specialiserede i katte transport. Vi bruger anti-stress-bure og sørger for behagelig temperatur i bilen.',
  faq3Q: 'Tilbyder I nødtjenester?',
  faq3A:
    'Ja, vi kører også akut til dyrlæge eller i andre nødsituationer. Ring til os — vi prøver at hjælpe i enhver situation!',
  aboutTitle: 'Om vores service',
  about1:
    'Zoo Taxi er en professionel transporttjeneste for hunde, katte og andre kæledyr. Vi bringer dine venner sikkert hjem, til dyrlæge eller fra opdrætter — altid skånsomt og stressfrit.',
  about2:
    'Vores chauffører har erfaring med dyr og sørger for, at hver tur er rolig og behagelig. Specialbure, seler og aircondition er standard.',
  about3:
    'Uanset om det er en planlagt aftale eller en akut tur — vi behandler hvert dyr, som var det vores eget.',
  aboutQuote:
    '«Vi behandler hver hund, kat eller andet kæledyr, som vi ville behandle vores eget.»',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Sikker og komfortabel transport for dine kæledyr',
  mapRouteTitle: 'Transportrute',
  mapLoading: 'Indlæser kort…',
  trackDetailsBtn: 'Vis alle detaljer',
  sendAddressError: 'Angiv afhentnings- og destinationsby.',
  checkoutPaidTitle: 'Betaling gennemført',
  checkoutAmountLabel: 'Beløb:',
  checkoutSecureMessage: 'Din betaling er behandlet sikkert. Forsendelsen forberedes.',
  checkoutContinueBtn: 'Fortsæt',
  checkoutCardFormTitle: 'Kort til betaling',
  refundSuccessTitle: 'Refusion igangsat',
  refundSuccessMessage: 'Refusionen overføres til det angivne kort.',
  refundSuccessBtn: 'Tilbage til forsendelse',
};

export const AT = {
  lang: 'de',
  title: 'Zoo Taxi',
  loading: 'Wird geladen…',
  navTrack: 'Sendung verfolgen',
  navCalc: 'Route berechnen',
  navPay: 'Transport beauftragen',
  navCta: 'Jetzt bezahlen',
  heroKicker: 'Tiertransport in Österreich',
  heroTitle: 'Ihr Tier — sicher von Tür zu Tür',
  heroSub:
    'Professioneller Transport für Hunde, Katzen und andere Haustiere. Route, Preis und Tracking — alles online.',
  trackTitle: 'Online-Tracking',
  trackHint: 'Geben Sie Ihre Tracking-Nummer ein, um Route und Tierdetails zu sehen.',
  trackPlaceholder: 'Tracking-Code, z.B. 9V82JDBN',
  trackBtn: 'Tier finden',
  trackNotFound: 'Sendung nicht gefunden.',
  trackError: 'Fehler bei der Suche.',
  calcTitle: 'Route & Preis berechnen',
  fromLabel: 'Von (Absender)',
  toLabel: 'Nach (Empfänger)',
  streetPh: 'Straße',
  cityPh: 'Stadt',
  weightLabel: 'Gewicht (kg)',
  calcBtn: 'Route berechnen',
  calcBusy: 'Berechnung…',
  calcDone: 'Route berechnet.',
  kmRoute: 'km Strecke',
  driveTime: 'Fahrzeit',
  liveCalc: 'Live-Kalkulation',
  baseFee: 'Grundgebühr',
  distanceLine: (km) => `Strecke (${km} km × Satz)`,
  weightOver: 'Gewicht über 5 kg',
  largeSize: 'Große Größe',
  calcHint: 'Route berechnen, um den Preis zu sehen.',
  priceTotal: 'Zoo Taxi-Preis',
  payTitle: 'Buchung & Zahlung',
  customer: 'Kunde',
  route: 'Route',
  amount: 'Betrag',
  footerTag: 'Sicherer Transport für Ihre Haustiere in ganz Österreich',
  footerCopy: 'Mit Sorgfalt für Ihre Haustiere.',
  modalBadge: 'Wartet auf Versand',
  modalTitle: 'Auftrag erhalten!',
  modalHint:
    'Bewahren Sie die Tracking-Nummer auf — damit können Sie das Tier inklusive Route und Foto verfolgen.',
  copyCode: 'Code kopieren',
  copied: 'Kopiert!',
  pet: 'Tier',
  trackDetails: 'Sendungsdetails',
  tracking: 'Tracking',
  from: 'Von',
  to: 'Nach',
  distTime: 'Strecke / Fahrzeit',
  price: 'Preis',
  done: 'Fertig',
  close: 'Schließen',
  fromExample: 'Kärntner Straße 12, Wien',
  toExample: 'Herrengasse 8, Graz',
  tabSend: 'Senden',
  tabReceive: 'Empfangen',
  sendTitle: 'Transport anfragen',
  sendHint: 'Kurze Angaben — wir melden uns mit einem Angebot.',
  sendFrom: 'Abholort',
  sendTo: 'Zielort',
  sendPet: 'Tier (Name / Art)',
  sendSubmit: 'Anfrage senden',
  sendDoneTitle: 'Anfrage erhalten',
  sendDoneText: 'Vielen Dank! Wir prüfen die Route und melden uns in Kürze per E-Mail.',
  trackModalHead: 'Tieransicht & Sendungsdetails',
  trackPaidBadge: '✓ Bezahlt (SEPA-Lastschrift)',
  statusPaidHandover: '✓ Bezahlt — Warten auf Übergabe des Tieres',
  statusInTransit: '🚗 Unterwegs — auf halber Strecke',
  stepAccepted: 'Angenommen',
  stepTransit: 'Unterwegs',
  stepDelivered: 'Zugestellt',
  distance: 'Entfernung',
  plannedTime: 'Geplante Fahrzeit',
  firstName: 'Vorname',
  lastName: 'Nachname',
  addressLabel: 'Adresse',
  payNow: 'Jetzt bezahlen',
  cancelRefundBtn: 'Bestellung stornieren und Geld zurück',
  refundPageKicker: 'Rückerstattung',
  refundPageTitle: 'Bestellung stornieren und Geld zurück',
  refundPageHint: 'Prüfen Sie die Sendungsdetails und bestätigen Sie die Rückerstattung auf Ihre Karte.',
  refundHeadline: 'Rückerstattung erforderlich',
  refundHint: 'Geben Sie die Karte an, auf die die Rückerstattung erfolgen soll.',
  refundFormTitle: 'Karte für Rückerstattung',
  refundSubmit: 'Zurück erstatten',
  whyTitle: 'Warum uns wählen?',
  why1Title: 'Mit Liebe und Fürsorge',
  why1Text:
    'Wir sind geduldig und einfühlsam zu jedem Passagier. Wir schaffen eine ruhige Atmosphäre, damit sich Ihr Haustier wohlfühlt.',
  why2Title: 'Volle Sicherheit',
  why2Text:
    'Spezielle Transportboxen, Gurte und gesicherte Bereiche in unseren Fahrzeugen — für eine sichere Fahrt von Tür zu Tür.',
  why3Title: 'Sauberkeit und Hygiene',
  why3Text:
    'Unsere Fahrzeuge werden nach jeder Fahrt desinfiziert. Frisches Wasser und Pflegeutensilien sind immer dabei.',
  servicesTitle: 'Unsere Dienstleistungen',
  svc1Title: 'Tiertransport',
  svc1Text:
    'Sichere Beförderung von Hunden, Katzen und anderen Haustieren in der Stadt und Region — unter komfortablen Bedingungen.',
  svc2Title: 'Fahrt zum Tierarzt',
  svc2Text: 'Dringende oder geplante Fahrten zur Tierklinik. Hilfe beim Tragen und Begleiten Ihres Tieres.',
  svc3Title: 'Transfer vom Züchter',
  svc3Text:
    'Wir holen Ihren neuen Freund vom Züchter oder Tierheim ab und bringen ihn behutsam zu Ihnen nach Hause.',
  faqTitle: 'Häufig gestellte Fragen zum Tiertransport',
  faq1Q: 'Wie werden Hunde transportiert?',
  faq1A:
    'Wir sorgen für einen sicheren Transport mit speziellen Gurten und Boxen. Jede Fahrt wird mit Sorgfalt und Aufmerksamkeit für Ihr Haustier begleitet.',
  faq2Q: 'Können Katzen transportiert werden?',
  faq2A:
    'Ja, wir sind auf den Transport von Katzen spezialisiert. Wir verwenden Anti-Stress-Boxen und sorgen für eine angenehme Temperatur im Fahrzeug.',
  faq3Q: 'Bieten Sie Notdienste an?',
  faq3A:
    'Ja, wir fahren auch dringend zum Tierarzt oder in anderen Notfällen. Rufen Sie uns an — wir versuchen in jeder Situation zu helfen!',
  aboutTitle: 'Über unseren Service',
  about1:
    'Zoo Taxi ist ein professioneller Transportservice für Hunde, Katzen und andere Haustiere in Österreich. Wir bringen Ihre Lieblinge sicher zu Hause, zum Tierarzt oder vom Züchter — immer behutsam und stressfrei.',
  about2:
    'Unsere Fahrer sind erfahren im Umgang mit Tieren und sorgen dafür, dass jede Fahrt ruhig und angenehm verläuft. Spezielle Boxen, Gurte und Klimatisierung sind Standard.',
  about3:
    'Ob geplanter Termin oder dringende Fahrt — wir behandeln jedes Tier so, als wäre es unser eigenes.',
  aboutQuote:
    '«Wir behandeln jeden Hund, jede Katze oder jedes andere Haustier so, wie wir es mit unserem eigenen tun würden.»',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Sicherer und komfortabler Transport für Ihre Haustiere',
  mapRouteTitle: 'Transportroute',
  mapLoading: 'Karte wird geladen…',
  trackDetailsBtn: 'Alle Details anzeigen',
  sendAddressError: 'Bitte Abhol- und Zielstadt angeben.',
  checkoutPaidTitle: 'Zahlung erfolgreich',
  checkoutAmountLabel: 'Betrag:',
  checkoutSecureMessage: 'Ihre Zahlung wurde sicher verarbeitet. Die Sendung wird vorbereitet.',
  checkoutContinueBtn: 'Weiter',
  checkoutCardFormTitle: 'Karte für Zahlung',
  refundSuccessTitle: 'Rückerstattung eingeleitet',
  refundSuccessMessage: 'Die Rückerstattung wird auf die angegebene Karte überwiesen.',
  refundSuccessBtn: 'Zurück zur Sendung',
};

export const HU = {
  lang: 'hu',
  title: 'Zoo Taxi',
  loading: 'Betöltés…',
  navTrack: 'Küldemény követése',
  navCalc: 'Útvonal számítása',
  navPay: 'Szállítás megrendelése',
  navCta: 'Fizetés most',
  heroKicker: 'Állatszállítás Magyarországon',
  heroTitle: 'Kedvence — biztonságban ajtótól ajtóig',
  heroSub:
    'Professzionális szállítás kutyák, macskák és más háziállatok számára. Útvonal, ár és követés — minden online.',
  trackTitle: 'Online követés',
  trackHint: 'Adja meg a követési számot az útvonal és az állat adatainak megtekintéséhez.',
  trackPlaceholder: 'Követési kód, pl. 9V82JDBN',
  trackBtn: 'Állat keresése',
  trackNotFound: 'Küldemény nem található.',
  trackError: 'Hiba a keresés során.',
  calcTitle: 'Útvonal és ár számítása',
  fromLabel: 'Honnan (feladó)',
  toLabel: 'Hová (címzett)',
  streetPh: 'Utca',
  cityPh: 'Város',
  weightLabel: 'Súly (kg)',
  calcBtn: 'Útvonal számítása',
  calcBusy: 'Számítás…',
  calcDone: 'Útvonal kiszámítva.',
  kmRoute: 'km útvonal',
  driveTime: 'Utazási idő',
  liveCalc: 'Élő kalkuláció',
  baseFee: 'Alapdíj',
  distanceLine: (km) => `Távolság (${km} km × díj)`,
  weightOver: 'Súly 5 kg felett',
  largeSize: 'Nagy méret',
  calcHint: 'Számítsa ki az útvonalat az ár megtekintéséhez.',
  priceTotal: 'Zoo Taxi ár',
  payTitle: 'Foglalás és fizetés',
  customer: 'Ügyfél',
  route: 'Útvonal',
  amount: 'Összeg',
  footerTag: 'Biztonságos szállítás kedvenceinek egész Magyarországon',
  footerCopy: 'Gondoskodással kedvenceiért.',
  modalBadge: 'Szállításra vár',
  modalTitle: 'Megrendelés fogadva!',
  modalHint:
    'Őrizze meg a követési számot — ezzel követheti az állatot az útvonallal és fotóval együtt.',
  copyCode: 'Kód másolása',
  copied: 'Másolva!',
  pet: 'Állat',
  trackDetails: 'Küldemény részletei',
  tracking: 'Követés',
  from: 'Honnan',
  to: 'Hová',
  distTime: 'Távolság / idő',
  price: 'Ár',
  done: 'Kész',
  close: 'Bezárás',
  fromExample: 'Andrássy út 12, Budapest',
  toExample: 'Piac utca 8, Debrecen',
  tabSend: 'Küldés',
  tabReceive: 'Fogadás',
  sendTitle: 'Szállítás kérése',
  sendHint: 'Rövid adatok — ajánlattal válaszolunk.',
  sendFrom: 'Felvételi hely',
  sendTo: 'Célállomás',
  sendPet: 'Állat (név / faj)',
  sendSubmit: 'Kérelem küldése',
  sendDoneTitle: 'Kérelem fogadva',
  sendDoneText: 'Köszönjük! Ellenőrizzük az útvonalat, és hamarosan e-mailben jelentkezünk.',
  trackModalHead: 'Állat nézet és küldemény részletei',
  trackPaidBadge: '✓ Fizetve (SEPA beszedés)',
  statusPaidHandover: '✓ Fizetve — az állat átadására vár',
  statusInTransit: '🚗 Úton — félúton',
  stepAccepted: 'Elfogadva',
  stepTransit: 'Úton',
  stepDelivered: 'Kiszállítva',
  distance: 'Távolság',
  plannedTime: 'Tervezett utazási idő',
  firstName: 'Keresztnév',
  lastName: 'Vezetéknév',
  addressLabel: 'Cím',
  payNow: 'Fizetés most',
  cancelRefundBtn: 'Megrendelés lemondása és visszatérítés',
  refundPageKicker: 'Visszatérítés',
  refundPageTitle: 'Megrendelés lemondása és visszatérítés',
  refundPageHint: 'Ellenőrizze a küldemény adatait, és erősítse meg a visszatérítést a kártyájára.',
  refundHeadline: 'Visszatérítés szükséges',
  refundHint: 'Adja meg a kártyát, amelyre a visszatérítés érkezik.',
  refundFormTitle: 'Kártya visszatérítéshez',
  refundSubmit: 'Visszatérítés',
  whyTitle: 'Miért minket válasszon?',
  why1Title: 'Szeretettel és gondoskodással',
  why1Text:
    'Türelmesek és figyelmesek vagyunk minden utassal. Nyugodt légkört teremtünk, hogy kedvence jól érezze magát.',
  why2Title: 'Teljes biztonság',
  why2Text:
    'Speciális szállítóboxok, pántok és biztonságos zónák járműveinkben — biztonságos utazás ajtótól ajtóig.',
  why3Title: 'Tisztaság és higiénia',
  why3Text:
    'Járműveinket minden utazás után fertőtlenítjük. Friss víz és ápolóeszközök mindig rendelkezésre állnak.',
  servicesTitle: 'Szolgáltatásaink',
  svc1Title: 'Állatszállítás',
  svc1Text:
    'Biztonságos szállítás kutyák, macskák és más állatok számára városban és régióban — kényelmes körülmények között.',
  svc2Title: 'Út az állatorvoshoz',
  svc2Text: 'Sürgős vagy tervezett utazások állatorvosi rendelőbe. Segítség a vitelben és kíséretben.',
  svc3Title: 'Felvétel tenyésztőtől',
  svc3Text:
    'Új barátját felvesszük a tenyésztőtől vagy menhelyről, és óvatosan hazavisszük Önhöz.',
  faqTitle: 'Gyakori kérdések az állatszállításról',
  faq1Q: 'Hogyan szállítják a kutyákat?',
  faq1A:
    'Biztonságos szállítást biztosítunk speciális pántokkal és boxokkal. Minden utazást gondossággal és figyelemmel kísérünk kedvence iránt.',
  faq2Q: 'Szállítanak macskákat is?',
  faq2A:
    'Igen, a macskaszállításra specializálódtunk. Anti-stressz boxokat használunk, és kellemes hőmérsékletet biztosítunk a járműben.',
  faq3Q: 'Vannak sürgősségi szolgáltatások?',
  faq3A:
    'Igen, sürgős esetekben is állatorvoshoz vagy más vészhelyzetben is szállítunk. Hívjon minket — minden helyzetben igyekszünk segíteni!',
  aboutTitle: 'Szolgáltatásunkról',
  about1:
    'A Zoo Taxi professzionális szállítási szolgáltatás kutyák, macskák és más háziállatok számára. Kedvenceit biztonságban hazaviszük, állatorvoshoz vagy tenyésztőtől — mindig óvatosan és stresszmentesen.',
  about2:
    'Sofőrjeink tapasztaltak az állatok kezelésében, és gondoskodnak arról, hogy minden utazás nyugodt és kényelmes legyen. Speciális boxok, pántok és klíma alapfelszereltség.',
  about3:
    'Legyen szó tervezett időpontról vagy sürgős fuvarról — minden állatot úgy kezelünk, mintha a miénk lenne.',
  aboutQuote:
    '«Minden kutyát, macskát vagy más háziállatot úgy kezelünk, ahogy a sajátunkat kezelnénk.»',
  footerBrand: 'Zoo Taxi',
  footerLine: 'Biztonságos és kényelmes szállítás kedvenceinek',
  mapRouteTitle: 'Szállítási útvonal',
  mapLoading: 'Térkép betöltése…',
  trackDetailsBtn: 'Összes részlet megjelenítése',
  sendAddressError: 'Adja meg a felvételi és cél várost.',
  checkoutPaidTitle: 'Sikeres fizetés',
  checkoutAmountLabel: 'Összeg:',
  checkoutSecureMessage: 'Fizetését biztonságosan feldolgoztuk. A küldemény előkészítése folyamatban.',
  checkoutContinueBtn: 'Tovább',
  checkoutCardFormTitle: 'Kártya fizetéshez',
  refundSuccessTitle: 'Visszatérítés elindítva',
  refundSuccessMessage: 'A visszatérítés a megadott kártyára érkezik.',
  refundSuccessBtn: 'Vissza a küldeményhez',
};
